<template>
  <div
    ref="dropDown"
    class="dropDown"
    @mousewheel.stop
  >
    <div
      class="showLabel"
      @mousedown="showSubMenu"
    >
      <span class="label">{{ selectedItem ? (selectedItem.name ? selectedItem.name : selectedItem) : '' }}</span>
      <div
        class="icon"
        :class="{ active: isActive }"
      >
        <iconfont
          name="#icon13-33xiala"
          font-size="8px"
        ></iconfont>
      </div>
    </div>
    <div
      ref="menu"
      class="dropdown-content"
      @mouseleave="hideSubMenu()"
    >
      <ul>
        <div
          v-for="(item, index) in menuList"
          :key="index"
          class="item"
          :class="{ disable: item.disable }"
          @click="itemClick(index, item)"
        >
          <span
            class="name"
            :class="{ disable: item.disable }"
          >{{ item.name ? item.name : item }}</span>
          <span
            class="description"
            :class="{ disable: item.disable }"
          >{{ item.description ? item.description : '' }}</span>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropDownMenu',
  model: {
    prop: 'selectedItem',
    event: 'selected'
  },
  props: {
    //下拉菜单选项
    menuList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    // displayName: {
    //   type: String,
    //   default() {
    //     return "name";
    //   }
    // },
    //selectedItem: [String, Object]
    selectedItem: null,
    direction: { type: String, default: '' }
  },
  data() {
    return {
      isActive: false
    };
  },
  watch: {},
  created() {},
  methods: {
    showSubMenu() {
      this.isActive = true;
      let rect = this.$refs.dropDown.getBoundingClientRect();
      this.$refs.menu.style.display = 'block';
      this.$refs.menu.style.opacity = 0;
      this.$refs.menu.style.left = `${rect.left}px`;
      this.$refs.menu.style.width = `${rect.width}px`;
      this.$refs.menu.style['padding-top'] = 0;
      this.$refs.menu.style['padding-bottom'] = 0;

      if (this.direction == 'up') {
        this.popUpStyle(rect);
      } else if (this.direction == 'down') {
        this.popDownStyle(rect);
      } else {
        let pageClientHeight = document.body.clientHeight;
        let menuHeight = this.$refs.menu.clientHeight;
        if (pageClientHeight - rect.bottom > menuHeight) {
          this.popDownStyle(rect);
        } else {
          this.popUpStyle(rect);
        }
      }

      this.$refs.menu.style.opacity = 1;
    },
    hideSubMenu() {
      this.$refs.menu.style.display = 'none';
      this.isActive = false;
    },
    mouseover() {
      if (this.$refs.menu.style.display == 'block') {
        this.$refs.menu.style.display == 'block';
      }
    },
    itemClick: function(index, item) {
      if (item.disable) return;
      if (item == this.selectedItem) return;
      this.$emit('selected', item);
      this.hideSubMenu();
    },

    popUpStyle(rect) {
      let menuHeight = this.$refs.menu.clientHeight;
      this.$refs.menu.style['transform-origin'] = '100% 100%';
      this.$refs.menu.style.top = `${rect.top - menuHeight}px`;
      this.$refs.menu.style['padding-bottom'] = `${rect.height}px`;
      this.$refs.menu.style['margin-top'] = '-3px';
    },
    popDownStyle(rect) {
      //let menuHeight = this.$refs.menu.clientHeight;
      this.$refs.menu.style['transform-origin'] = '0 0';
      this.$refs.menu.style.top = `${rect.top}px`;
      this.$refs.menu.style['padding-top'] = `${rect.height}px`;
      this.$refs.menu.style['margin-top'] = '3px';
    }
  }
};
</script>

<style scoped lang="scss">
@keyframes slide-down {
  0% {
    transform: scale(1, 0);
  }
  100% {
    transform: scale(1, 1);
  }
}

.dropDown {
  background-color: #fff;
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  font-size: 14px;
}
.showLabel {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  .label {
    flex-grow: 1;
    margin-right: auto;
    //height: 100%;
    //line-height: 100%;
    text-align: left;
    padding-left: 14px;
    // font-size: 14px;
    color: #343434;
  }
  .icon {
    margin-right: 14px;
    transform-origin: center center;
    transition: all 0.3s;
  }
  .active {
    transform: rotate(180deg);
  }
}

.dropdown-content {
  position: relative;
  display: none;
  position: fixed;
  z-index: 60;
  //transform-origin: 100% 100%;
  animation: slide-down 0.3s ease-in;
  //margin-top: -3px;
  //margin-bottom: -3px;
  //transition: max-height 0.3s ease-in;

  > ul {
    width: 100%;
    // height: 176px;
    background: #ffffff;
    box-shadow: 1px 2px 9px 1px rgba(56, 59, 66, 0.2);
    border-radius: 4px;

    .item {
      width: 100%;
      height: 36px;

      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 14px;

      &:hover {
        background: #f6f7f9;
        cursor: pointer;
      }

      .name {
        //line-height: 34px;
        text-align: left;
        // padding-left: 16px;
        //font-size: 14px;
        color: #343434;
      }
      .description {
        //font-size: 14px;
        color: #9a9a9a;
      }
      .disable {
        color: #d5d5d5;
      }
    }
    .disable {
      pointer-events: none;
      cursor: none;
    }
  }
}
</style>
